/**
 * React Query key factory for the Advertising Optimization arche.
 * Per-arche key ownership (social-media pilot pattern). Every data-bearing
 * key takes `holder` as its first segment so two Holders' data are fully
 * independent caches.
 */
export const adoptQueryKeys = {
  all: ['advertising-optimization'] as const,

  campaigns: (holder: string) => [...adoptQueryKeys.all, 'campaigns', holder] as const,
  campaignsList: (holder: string, filters: { status?: string; promotedArcheId?: string }) =>
    [...adoptQueryKeys.campaigns(holder), 'list', filters] as const,
  campaign: (holder: string, campaignId: string) =>
    [...adoptQueryKeys.campaigns(holder), campaignId] as const,

  settings: (holder: string) => [...adoptQueryKeys.all, 'settings', holder] as const,
  dailyAdLimit: (holder: string) => [...adoptQueryKeys.all, 'daily-ad-limit', holder] as const,
  spendCaps: (holder: string) => [...adoptQueryKeys.all, 'spend-caps', holder] as const,
  dailyDigest: (holder: string) => [...adoptQueryKeys.all, 'daily-digest', holder] as const,

  links: (holder: string) => [...adoptQueryKeys.all, 'links', holder] as const,

  accounts: (holder: string) => [...adoptQueryKeys.all, 'accounts', holder] as const,

  placements: (holder: string, campaignId: string) =>
    [...adoptQueryKeys.all, 'placements', holder, campaignId] as const,

  creatives: (holder: string, campaignId: string) =>
    [...adoptQueryKeys.all, 'creatives', holder, campaignId] as const,

  generations: (holder: string, campaignId: string) =>
    [...adoptQueryKeys.all, 'generations', holder, campaignId] as const,

  actions: (holder: string) => [...adoptQueryKeys.all, 'actions', holder] as const,
  actionsList: (holder: string, filters: { status?: string; campaignId?: string }) =>
    [...adoptQueryKeys.actions(holder), 'list', filters] as const,
  autoUnlock: (holder: string) => [...adoptQueryKeys.all, 'auto-unlock', holder] as const,
  access: (holder: string) => [...adoptQueryKeys.all, 'access', holder] as const,
  workspaceAccess: (holder: string) => [...adoptQueryKeys.all, 'workspace-access', holder] as const,

  experiments: (holder: string) => [...adoptQueryKeys.all, 'experiments', holder] as const,
  experiment: (holder: string, experimentId: string) =>
    [...adoptQueryKeys.experiments(holder), experimentId] as const,
  experimentResults: (holder: string, experimentId: string) =>
    [...adoptQueryKeys.experiments(holder), experimentId, 'results'] as const,
};
